export let Environment;
(function (Environment) {
  Environment["Local"] = "local";
  Environment["QA"] = "qa";
  Environment["Prod"] = "prod";
})(Environment || (Environment = {}));